<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field appearance="fill">
        <mat-label>Edit First Name</mat-label>
        <input matInput placeholder="Enter Event Name" [(ngModel)]="show.first_name" required />
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Edit Last Name</mat-label>
        <input matInput placeholder="Enter Event Name" [(ngModel)]="show.last_name" required />
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Edit Email</mat-label>
        <input matInput placeholder="Enter Email" [(ngModel)]="show.email_address" required />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancel-popup" mat-stroked-button mat-dialog-close (click)="close()">Cancel</button>
    <button class="popup-save" mat-flat-button
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" type="submit"
        (click)="save()" [disabled]="processing">
        <mat-icon *ngIf="processing">
            <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
        </mat-icon>
        Save
    </button>
</mat-dialog-actions>
